import PostConfettiBanner from './post-confetti-banner'

export default PostConfettiBanner
